import React, { Component } from "react";
import { Provider } from "store";
import styled, { createGlobalStyle } from "styled-components";
import LeftNav from "./LeftNav";
import { Router } from "react-router";
import history from "services/history";
import Routes from "./Routes";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";

const THEME_STORAGE_KEY = "playground-admin-theme";

const GlobalStyle = createGlobalStyle`
  :root {
    --app-bg: ${({ isDark }) => (isDark ? "#11161b" : "#f6f7f9")};
    --surface-bg: ${({ isDark }) => (isDark ? "#161d24" : "#ffffff")};
    --nav-bg: ${({ isDark }) => (isDark ? "#0f1419" : "#ffffff")};
    --text-color: ${({ isDark }) => (isDark ? "#e8edf2" : "#16161d")};
    --muted-text: ${({ isDark }) => (isDark ? "rgba(232, 237, 242, 0.68)" : "rgba(0, 0, 0, 0.65)")};
    --border-color: ${({ isDark }) => (isDark ? "rgba(255,255,255,0.10)" : "rgba(0,0,0,0.05)")};
    --button-bg: ${({ isDark }) => (isDark ? "#1b2430" : "#ffffff")};
    --button-text: ${({ isDark }) => (isDark ? "#e8edf2" : "#16161d")};
    --button-shadow: ${({ isDark }) => (isDark ? "0 8px 24px rgba(0, 0, 0, 0.32)" : "2px 2px 5px 0px rgba(0, 0, 0, 0.2)")};
    --button-shadow-active: ${({ isDark }) => (isDark ? "0 4px 16px rgba(0, 0, 0, 0.36)" : "1px 1px 5px 0px rgba(0, 0, 0, 0.1)")};
    --input-bg: ${({ isDark }) => (isDark ? "#121921" : "#ffffff")};
    --input-border: ${({ isDark }) => (isDark ? "rgba(255,255,255,0.14)" : "rgba(0,0,0,0.14)")};
    --link-hover-bg: rgba(66, 244, 179, 0.10);
  }

  html, body, #root {
    width: 100%;
    height: 100%;
    margin: 0;
    background: var(--app-bg);
    color: var(--text-color);
  }

  body {
    transition: background 0.2s ease, color 0.2s ease;
  }

  a {
    color: inherit;
  }

  input,
  textarea,
  select {
    background: var(--input-bg);
    color: var(--text-color);
    border: 1px solid var(--input-border);
  }

  input::placeholder,
  textarea::placeholder {
    color: var(--muted-text);
  }

  .bp3-dialog,
  .bp3-dialog-body,
  .bp3-dialog-footer {
    background: var(--surface-bg);
    color: var(--text-color);
  }
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--app-bg);
  display: flex;
  color: var(--text-color);
  * {
    box-sizing: border-box;
    font-family: "Lato", sans-serif;
  }
`;

const Content = styled.div`
  flex: 1;
  height: 100%;
  max-height: 100%;
  overflow: auto;
  background: var(--app-bg);
`;

class App extends Component {
  state = {
    isDarkMode: false
  };

  componentDidMount() {
    try {
      const savedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
      if (savedTheme === "dark") {
        this.setState({ isDarkMode: true });
      }
    } catch (e) {}
  }

  toggleTheme = () => {
    this.setState(
      state => ({ isDarkMode: !state.isDarkMode }),
      () => {
        try {
          window.localStorage.setItem(
            THEME_STORAGE_KEY,
            this.state.isDarkMode ? "dark" : "light"
          );
        } catch (e) {}
      }
    );
  };

  render() {
    const { isDarkMode } = this.state;

    return (
      <Provider>
        <Router history={history}>
          <React.Fragment>
            <GlobalStyle isDark={isDarkMode} />
            <Container>
              <LeftNav isDarkMode={isDarkMode} onToggleTheme={this.toggleTheme} />
              <Content>
                <Routes />
              </Content>
            </Container>
          </React.Fragment>
        </Router>
      </Provider>
    );
  }
}

export default App;
